import Layout from '@/layout/Layout.vue'
import { P, ROLES } from '@/config/permissions'

const hostingRoutes = {
  path: '/hosting',
  component: Layout,
  name: 'Hosting',
  meta: {
    title: 'Hébergement',
    permissions: [P.HESTIA.SERVERS_BROWSE, P.HESTIA.ACCOUNTS_BROWSE],
    // Le rôle écarte l'extranet : un client peut porter un droit `hestia-*`,
    // et canAccess ne regarde pas la catégorie du rôle.
    roles: [ROLES.ADMIN, ROLES.ADMIN_HEBERGEMENT],
  },
  children: [
    {
      path: '',
      component: () => import('@/views/hosting/HostingAdmin.vue'),
      name: 'HostingAdmin',
      meta: {
        title: 'Hébergement',
        icon: 'mdi:server-network',
        permissions: [P.HESTIA.SERVERS_BROWSE, P.HESTIA.ACCOUNTS_BROWSE],
        roles: [ROLES.ADMIN, ROLES.ADMIN_HEBERGEMENT],
        noCache: true,
      },
    },
  ],
}

export default hostingRoutes
